import { Route } from 'react-router-dom';
import { GAME_TYPE_LIVE } from 'utils/constants/sportsbook/generic';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { mountPoint } from 'utils/generic/route-manipulation';
import { routePathWithMockedDataCheck } from 'utils/helpers';
import {
  EOlympicLayoutType,
  ETopLeagueLayoutType
} from 'interfaces/sportsbook-configs';
import { FavoriteSideBarSearchSection } from 'elements/SportsbookLeftSideBar/FavoriteSideBarSearchSection';
import { TopLeagueCompactMenuItemWithWrapper } from 'elements/SportsbookLeftSideBar/TopLeagueCompactMenuItemWithWrapper';
import { AdvancedLeftMenu } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedLeftSideBar/AdvancedLeftMenu';
import { AdvancedLiveGamesList } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedLiveGamesList';
import { OlympicCompetitionCompactLayout } from 'newcomponents/Shared/sportsbook/OlympicCompetitionCompactLayout';
import { useSearchParams } from 'hooks/useSearchParams';

export const AdvancedLeftSideBar = () => {
  const { gameType } = useSearchParams();

  const isLiveSingleGameView = Number(gameType) === GAME_TYPE_LIVE;

  const showTopLeague =
    SpringConfigs.TOP_LEAGUES_LAYOUT === ETopLeagueLayoutType.compact &&
    SpringConfigs.TOP_LEAGUES;

  const showOlympic =
    SpringConfigs.OLYMPIC_COMPETITION_LAYOUT === EOlympicLayoutType.compact &&
    SpringConfigs.OLYMPIC_COMPETITION;

  return (
    <Route
      exact
      path={routePathWithMockedDataCheck(
        `${mountPoint(
          window.getPathname()
        )}/:sport?/:region?/:competition?/:game?`
      )}
      render={routeParams => {
        const { sport, region, competition, game } = routeParams.match.params;
        const isLiveGameSingleView =
          sport && region && competition && game && isLiveSingleGameView;

        return (
          <>
            <FavoriteSideBarSearchSection />
            {isLiveGameSingleView ? (
              <AdvancedLiveGamesList />
            ) : (
              <>
                {showTopLeague ? <TopLeagueCompactMenuItemWithWrapper /> : null}
                {showOlympic ? <OlympicCompetitionCompactLayout /> : null}
                <AdvancedLeftMenu />
              </>
            )}
          </>
        );
      }}
    />
  );
};
